/* Ecommerce Events */
window.analytics = window.analytics || {};

window.analytics.trackViewItemEvent = function (product, variantObj) {
  if (!product) {
    console.error('Invalid product object');
    return;
  }

  const variant = variantObj || product.variants[0] || product.selected_or_first_available_variant;

  const viewItemEvent = {
    event: 'view_item_ga4',
    ecommerce: {
      currency: 'USD',
      value: (variant.price / 100) || 0.00,
      items: [
        {
          item_id: variant.sku || '',
          item_variant: variant.title || '',
          item_name: product.title || '',
          item_category: product.type || '',
          discount: product.compare_at_price
            ? ((product.compare_at_price - product.price) / 100)
            : 0.00,
          price: (product.price / 100) || 0.00,
          quantity: 1,
        },
      ],
    },
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(viewItemEvent);
};

window.analytics.trackViewItemListEvent = function (collection, productsArray, numOfProducts) {
  if (!collection) {
    console.error('Missing collection data');
    return;
  }

  let products = productsArray || collection.products;
  if (numOfProducts) {
    products = products.slice(0, numOfProducts);
  }

  const viewItemListEvent = {
    event: 'view_item_list_ga4',
    ecommerce: {
      item_list_id: collection.id,
      item_list_name: collection.title,
      items: products.map((product, index) => ({
        index,
        item_id: product.variants[0].sku || '',
        item_name: product.title || '',
        item_variant: product.variants[0].title || '',
        item_category: product.type || '',
        price: (product.price / 100) || 0.00,
        discount: product.compare_at_price
          ? ((product.compare_at_price - product.price) / 100)
          : 0.00,
        quantity: 1,
      })),
    },
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(viewItemListEvent);
};

window.analytics.trackSelectItemEvent = function (product, collection) {
  if (!product) {
    console.error('Invalid product object');
    return;
  }

  const variant = product.variants[0] || product.selected_or_first_available_variant;

  const selectItemEvent = {
    event: 'select_item_ga4',
    ecommerce: {
      item_list_id: collection.id || '',
      item_list_name: collection.title || '',
      items: [
        {
          item_id: variant.sku || '',
          item_variant: variant.title || '',
          item_name: product.title || '',
          item_category: product.type || '',
          discount: product.compare_at_price
            ? ((product.compare_at_price - product.price) / 100)
            : 0.00,
          price: (product.price / 100) || 0.00,
          quantity: 1,
        },
      ],
    },
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(selectItemEvent);
};

window.analytics.trackAddToCartEvent = function (product, variantObj, quantity) {
  if (!product) {
    console.error('Invalid product object');
    return;
  }

  const variant = variantObj || product.variants[0] || product.selected_or_first_available_variant;

  const addToCartEvent = {
    event: 'add_to_cart_ga4',
    ecommerce: {
      currency: 'USD',
      value: (variant.price / 100) || 0.00,
      items: [
        {
          item_id: variant.sku || '',
          item_variant: variant.title || '',
          item_name: product.title || '',
          item_category: product.type || '',
          discount: product.compare_at_price
            ? ((product.compare_at_price - product.price) / 100)
            : 0.00,
          price: (product.price / 100) || 0.00,
          quantity,
        },
      ],
    },
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(addToCartEvent);
};

window.analytics.trackRemoveFromCartEvent = function (product, variantObj, quantity) {
  if (!product) {
    console.error('Invalid product object');
    return;
  }

  const variant = variantObj || product.variants[0] || product.selected_or_first_available_variant;

  const removeFromCartEvent = {
    event: 'remove_from_cart',
    ecommerce: {
      currency: 'USD',
      value: (variant.price / 100) || 0.00,
      items: [
        {
          item_id: variant.sku || '',
          item_variant: variant.title || '',
          item_name: product.title || '',
          item_category: product.type || '',
          discount: product.compare_at_price
            ? ((product.compare_at_price - product.price) / 100)
            : 0.00,
          price: (product.price / 100) || 0.00,
          quantity,
        },
      ],
    },
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(removeFromCartEvent);
};

window.analytics.trackViewCartEvent = function (cart) {
  if (!cart) {
    console.error('Invalid cart object');
    return;
  }

  const viewCartEvent = {
    event: 'view_cart_ga4',
    ecommerce: {
      currency: 'USD',
      value: (cart.total_price / 100) || 0.00,
      items: cart.items.map((item) => ({
        item_id: item.sku || '',
        item_variant: item.variant_title || '',
        item_name: item.title || '',
        item_category: item.product_type || '',
        discount: (item.original_price - item.final_price) / 100 || 0.00,
        price: (item.original_price / 100) || 0.00,
        quantity: item.quantity,
      })),
    },
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(viewCartEvent);
};